// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_LzP","cls2":"LettersModal-cls2_qUn LettersModal-cls1_LzP"};